<template>
    <button  :class="customClasses" class="fill-button">
        <slot></slot>
		<span class="icon" v-if="hasIcon" v-html="displayArrowIcon()" />
    </button>
</template>


<script>

import { arrow, download } from '@/components/../icons';

export default {
	name: 'button-vue',
	props: {
		type : String,
		iconColor: {
			type: String,
			default: '#fff' //any Valid color
		},
		iconType: {
			type: String,
			default: 'link' //can use link, download, external
		},
		hasIcon: {
			type: Boolean,
			default: false
		},
		bold: {
			type: Boolean,
			default: false
		},
		link: {
			type: Boolean,
			default: false
		},
		uppercase: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		customClasses(){
			let custom = [];
			if(this.type) custom.push(this.type);
			if(this.bold) custom.push('bold');
			if(this.uppercase) custom.push('uppercase');
			if(this.link) custom.push('link');
			if(this.hasIcon){
				custom.push('has-icon');
				custom.push('icon-'+this.iconType);
			}
			return custom.splice(' ')
		}
	},
	methods: {
		displayArrowIcon(){
			if(this.iconType === 'download'){
				return download(this.iconColor)
			}else{
				return arrow(this.iconColor)
			}
        }
	}
	
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.fill-button {
	border: 2px solid $dark;
	border-radius: $radius;
	color: #fff;
	cursor: pointer;
    @include fluid-type($smallResText, $wideResText, 14px, 18px);
	font-weight: 400;
	font-family: $secndaryFont;
	overflow: hidden;
	padding: 12px 25px;
	position: relative;
	text-decoration: none;
	line-height: 1;
	background-color: $dark;
	transition: 0.2s color ease-in-out, 0.2s transform ease-in-out;
	will-change: color, transform;
	z-index: 0;
	@include mquery($tablet){
		padding: 10px 20px;
	}
	@include mquery($phone){
		padding: 8px 16px;
	}
	&:after{
		background-color: $yellow;
		border-radius: $radius;
		content: '';
		display: block;
		height: 100%;
		width:100%;
		position: absolute;
		left: 0;
		top: 0;
		transform: translate(-100%, 0) rotate(10deg);
		transform-origin :top left;
		transition: 0.2s transform ease-out;
		will-change: transform;
		z-index: -1;
	}
	&:hover, &.hover{
		border: 2px solid transparent;
		color: $dark;
		transform: scale(1.05);
		will-change: transform;
		&:after{
			transform: translate(0, 0)
		}
		.icon{
			svg{
				path {
					transition: 0.2s fill ease-out;
				}
			}
		}
	}
	&.has-icon{
		align-items: center;
		&.icon-download{
			svg{
				//transform: rotate(-90deg);
			}
		}
		&.icon-external{
			svg{
				transform: rotate(135deg);
			}
		}
		&.icon-down{
			svg{
				transform: rotate(-90deg);
			}
		}
		&.icon-link{
			svg{
				transform: rotate(180deg)
			}
		}
		.icon{
			display: inline-block;
			margin-left: 20px;
		}
	}
	&.link{
		padding: 0;
		a{
			padding: 12px 25px;
			display: block;
			color: inherit !important;
			text-decoration: none !important;
			position: relative;
			width: 100%;
			text-align: left;
			z-index: 5;
			@include mquery($tablet){
				padding: 10px 20px;
			}
			@include mquery($phone){
				padding: 8px 16px;
			}
		}
	}
	
	&.uppercase{
		text-transform: uppercase;
	}
	&.bold{
		font-weight: 700;
	}	
	&.light{
		background-color: $light;
		border-color: $light;
		color: $darkLight;
		&:after{
			background-color: $darkLighten;
		}
		.icon{
				svg{
					path {
						fill: $darkLight
					}
				}
			}
		&:hover, &.hover{
			color: $dark;
			.icon{
				svg{
					path {
						fill: $dark
					}
				}
			}
		}
	}
	&.darkLight{
		background-color: $darkLight;
		border-color: $darkLight;
		color: #fff;
		&:after{
			background-color: #fff;
		}
		&:hover, &.hover{
			color: $dark;
			.icon{
				svg{
					path {
						fill: $dark
					}
				}
			}
		}
	}
	&.white{
		background-color: white;
		border-color: white;
		color: $dark;
		&:after{
			background-color: $darkLighten;
		}
		.icon{
			svg{
				path {
					fill: $dark
				}
			}
		}
		&:hover, &.hover{
			color: #fff;
			.icon{
				svg{
					path {
						fill: #fff
					}
				}
			}
		}
	}
	&.yellow{
		background-color: $yellow;
		border-color: $yellow;
		color: $dark;
		&:after{
			background-color: $dark;
		}
		&:hover, &.hover{
			color: #fff;
		}
	}
	&.yellowLight{
		background-color: $yellowLight;
		border-color: $yellowLight;
		color: $dark;
		&:after{
			background-color: $yellow;
		}
		&:hover, &.hover{
			//background-color: $yellow;
		}
	}
}

</style>